import ConversationService from "../../service/ConverstionService";
import swal from 'sweetalert'
//import router from "../../router";



export const state = {
    conversations:[],
    conversationLoading: false,
    response:{}

}

export const mutations = {
    updateConversations: (state, payload) =>{
        state.conversations = payload
    },
    updateConversationLoading: (state, payload) =>{
        state.conversationLoading = payload
    },
    updateResponse: (state, payload) =>{
        state.response = payload
    },
}

export const actions = {
    updateConversations: ({ commit, state }, payload)=>{
        if(state.conversations.length < 1)
            commit("updateConversationLoading", true)
        return ConversationService.callReadApi(payload)
            .then(response => {
                commit("updateConversationLoading", false)
                if (response.data.responseCode === "00") {
                    commit("updateConversationLoading", false)
                    let responseData = response.data;
                    commit("updateConversations", responseData.data)
                }

            })
            .catch(error => {
                commit("updateConversationLoading", false)
                alert(error)
                // throw error;
            });
    },
    createConversation: ({ commit }, payload)=>{
        commit("updateConversationLoading", true)
        return ConversationService.callCreateApi(payload)
            .then(response => {
                commit("updateConversationLoading", false)
                let responseData = response.data
                if (responseData.responseCode === "00") {
                    swal('Success!', responseData.responseMessage, 'success')
                }else{
                    swal('Error!', responseData.responseMessage, 'error')
                }
            })
            .catch(error => {
                commit("updateConversationLoading", false)
                alert(error)
                // throw error;
            });
    },
    createTranscript: ({ commit }, payload)=>{
        commit("updateConversationLoading", true)
        return ConversationService.callCreateTranscriptApi(payload)
            .then(response => {
                commit("updateConversationLoading", false)
                // eslint-disable-next-line no-unused-vars
                let responseData = response.data

                // if (responseData.responseCode === "00") {
                //     swal('Success!', responseData.responseMessage, 'success')
                // }else{
                //     swal('Error!', responseData.responseMessage, 'error')
                // }
            })
            .catch(error => {
                commit("updateConversationLoading", false)
                alert(error)
                // throw error;
            });
    },
}